import type { UserSession } from "../../types/session";

const mapUserSessionToTrackingData = (session: UserSession) => {
  const impersonating = !!session?.impersonatedBy?.name
  const account = session?.accounts?.[0];
  const accountId = account?.Id;
  const accountName = account?.Name;

  const trackingData: Record<string, string|undefined> = {
    impersonating: impersonating ? 'true' : 'false',
    email: session?.email ?? undefined,
    sfUserId: session?.id ?? undefined,
    sfAccountId: accountId ?? undefined,
    accountName: accountName ?? undefined,
    sessionEmail: session?.email ?? undefined,
    sessionName: session?.name ?? undefined,
    sessionUsername: session?.username ?? undefined,
    sessionProfileId: session?.profile_id ?? undefined,
    sessionVisitorId: session?.visitorId ?? undefined,
    sessionIsCustomer: session?.customer ? 'true' : 'false',
    contactId: session?.contact?.Id ?? undefined,
    contactFirstName: session?.contact?.FirstName ?? undefined,
    contactLastName: session?.contact?.LastName ?? undefined,
    contactPhone: session?.contact?.Phone ?? undefined,
    contactEmail: session?.contact?.Email ?? undefined,
    contactAccountId: session?.contact?.AccountId ?? undefined,
    contactJobFunction: session?.contact?.Job_Function__c ?? undefined,
    contactJiraUsername: session?.contact?.JIRA_Username__c ?? undefined,
  }

  return Object.keys(trackingData).reduce<Record<string, string>>((acc, key) => {
    if (typeof trackingData[key] !== undefined) {
      acc[key] = trackingData[key] as string;
    }
    return acc;
  }, {})
}

export default mapUserSessionToTrackingData;